import { callAjaxIO } from 'Shared/ajax_io';
import { FrameModules } from 'Shared/frame_modules';

FrameModules.add('CommentsWatchFrameModule', () => {
   const on = document.querySelector('#commentsWatchOn');
   const off = document.querySelector('#commentsWatchOff');

   if (on) {
      toggleWatchOnClick(on, 'on', off);
   }

   if (off) {
      toggleWatchOnClick(off, 'off', on);
   }
});

// Pressing a button saves the new status, then swaps in the other button
function toggleWatchOnClick(current, status, other) {
   const button = current.querySelector('.js-toggle-watch');
   button.addEventListener('click', async ev => {
      ev.preventDefault();
      ev.stopPropagation();
      await callAjaxIO('watch', status, button.dataset.context, button.dataset.contextid);
      current.style.display = 'none';
      other.style.display = 'inline';
   });
}
